import { logger } from '../util/logger'

/**
 * Service Worker related functionality
 * @module util/serviceWorker
 */

/**
 * Register service worker
 */
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function(registration) {
          // Registration was successful
          logger.info(
            'ServiceWorker registration successful with scope: ',
            registration.scope
          )
        })
        .catch(function(err) {
          // registration failed :(
          logger.error(err)
        })
    })
  }
}
